import '../styles/loader.scss';

const Loader = () => (
  <div className="loader-container">
    <div className="loader" />
  </div>
);

export default Loader;
